<template>
  <generic-modal
    :value="value"
    :is-disabled="isDisabled"
    :is-loading="isLoading"
    title="Mass Meta Import"
    persistent
    confirm-text="Import"
    hide-louis
    @modal-confirm="onCreateConfirm"
    @modal-cancel="onCreateCancel"
  >
    <div class="d-flex text-caption mb-8">
      <v-icon class="mr-1" small>info</v-icon>
      <span>This modal is to bulk import meta titles and descriptions.</span>
    </div>

    <v-form ref="form">
      <v-file-input v-model="file" accept=".csv, application/vnd.ms-excel" label="Select CSV File" prepend-icon="" />
    </v-form>
  </generic-modal>
</template>

<script>
import GenericModal from '@/components/modals/generic-modal'
import { pages } from '@/services/offers'

export default {
  components: { GenericModal },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    isLoading: false,
    file: null,
  }),
  computed: {
    isDisabled() {
      if (this.isLoading) return true
      return !this.file
    },
  },
  methods: {
    async onCreateConfirm() {
      this.isLoading = true

      try {
        const formData = new FormData()
        formData.append('data', this.file)
        const res = await pages.importMassMeta(formData)
        console.log(res)
        this.file = null
        this.$notify({ type: 'success', text: `Succesfully imported meta for ${res.length} pages.` })
        this.onCreateCancel()
      } catch (error) {
        this.$notify({ type: 'error', text: 'Unable to import meta.', data: { error }, duration: -1 })
      }

      this.isLoading = false
    },
    onCreateCancel() {
      this.$emit('cancel')
    },
  },
}
</script>
